module.exports = __webpack_public_path__ + "img/time-active.af084858.svg";